import { ParsedPackage } from "./types";

export function calculateVolumeCm3({
  height,
  width,
  length,
}: {
  height: number;
  width: number;
  length: number;
}) {
  return height * width * length;
}

export function calculateAforoKg({
  height,
  width,
  length,
}: {
  height: number;
  width: number;
  length: number;
}) {
  const lengthM = length / 100;
  const heightM = height / 100;
  const widthM = width / 100;

  return Number((lengthM * heightM * widthM * 250).toFixed(2));
}

export function buildParsedPackage({
  label,
  weight,
  height,
  width,
  length,
}: {
  label?: string;
  weight: number;
  height: number;
  width: number;
  length: number;
}): ParsedPackage {
  return {
    label,
    weight,
    height,
    width,
    length,
    volumeCm3: calculateVolumeCm3({ height, width, length }),
    aforoKg: calculateAforoKg({ height, width, length }),
  };
}

export const DEFAULT_CP_DESTINATIONS = [
  "1000",
  "1407",
  "1704",
  "1757",
  "2000",
  "3000",
  "5000",
  "5500",
  "7600",
  "8300",
  "9000",
  "9211",
  "9400",
];

export const STANDARD_PACKAGE_PRESETS: ParsedPackage[] = [
  buildParsedPackage({
    label: "Sobre chico",
    weight: 250,
    height: 2,
    width: 15,
    length: 20,
  }),
  buildParsedPackage({
    label: "Caja chica 1kg",
    weight: 1000,
    height: 10,
    width: 20,
    length: 30,
  }),
  buildParsedPackage({
    label: "Caja 2.5kg",
    weight: 2500,
    height: 10,
    width: 20,
    length: 30,
  }),
  buildParsedPackage({
    label: "Caja 5kg",
    weight: 5000,
    height: 20,
    width: 30,
    length: 40,
  }),
  buildParsedPackage({
    label: "Caja 10kg",
    weight: 10000,
    height: 30,
    width: 40,
    length: 50,
  }),
  buildParsedPackage({
    label: "Caja 15kg",
    weight: 15000,
    height: 40,
    width: 40,
    length: 60,
  }),
  buildParsedPackage({
    label: "Caja 20kg",
    weight: 20000,
    height: 50,
    width: 50,
    length: 70,
  }),
  buildParsedPackage({
    label: "Máximo Correo 25kg",
    weight: 25000,
    height: 60,
    width: 80,
    length: 100,
  }),
];

export const STRESS_PACKAGE_PRESETS: ParsedPackage[] = [
  buildParsedPackage({
    label: "Sobrepeso 26kg",
    weight: 26000,
    height: 60,
    width: 80,
    length: 100,
  }),
  buildParsedPackage({
    label: "Sobrepeso 30kg",
    weight: 30000,
    height: 60,
    width: 80,
    length: 100,
  }),
  buildParsedPackage({
    label: "Volumen grande 100cm",
    weight: 10000,
    height: 100,
    width: 100,
    length: 100,
  }),
  buildParsedPackage({
    label: "Máximo dimensión 150cm",
    weight: 10000,
    height: 150,
    width: 150,
    length: 150,
  }),
  buildParsedPackage({
    label: "Excede dimensión 151cm",
    weight: 10000,
    height: 151,
    width: 50,
    length: 50,
  }),
];

export function packagesToTextareaValue(packages: ParsedPackage[]) {
  return packages
    .map(
      (item) =>
        `${item.weight},${item.height},${item.width},${item.length}`
    )
    .join("\n");
}

export function cpListToTextareaValue(cps: string[]) {
  return cps.join("\n");
}